// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__PV8AL","col":"styles_col__-W4H8","fulfillmentStatus":"styles_fulfillmentStatus__2K_a6","emailCol":"styles_emailCol__lh61G"};